import { EApiLanguageCode } from '@datatype/iyagigo/api-type';
/** @jsxImportSource @emotion/react */

import React from 'react';
import { useTypedSelector } from '@hook/common/useStore';
import TestHome from '@component/iyagigo/test/test-home';
import PageTemplate from '@page/iyagigo/page-template';

const TestHomePage: React.FC<any> = () => {
  // ############### state ###############
  const studyLanguage = useTypedSelector((state) => state.rootReducer?.studentReducer?.currentStudyLanguage) ?? null;

  // ############### variable ###############
  const HEADER_TITLE = studyLanguage === EApiLanguageCode.ENGLISH ? '영어 시험' : '일본어 시험';

  return (
    <PageTemplate title={HEADER_TITLE} mode={'page'}>
      <TestHome />
    </PageTemplate>
  );
};

export default TestHomePage;
